import reducer from './actions'
export default reducer
export { closeComposerContentDialog, closeVideoCoverDialog, openComposerContentDialog, openVideoCoverDialog } from './actions'
export type { ComposerContentDialogTab, VideoCoverDialogTab } from './state'

